<nz-form-control *ngIf="recordProperty !== undefined">
    <nz-input-number
    [class]="parentClass"
     [nzFormatter]="formatterPrice" nzMin="0" [name]="sectionTagName+'.' +field.FieldName"
        [(ngModel)]="recordProperty.ValueAsObject" [ngModelOptions]="{ updateOn: 'blur'}" (ngModelChange)="valueChanged()"
        [nzDisabled]="recordProperty.ReadOnly" [nzParser]="numberParser">
    </nz-input-number>
</nz-form-control>
